export default __webpack_public_path__ + "static/media/about-us-section-three-mobile.de21f9fb.png";